import { Nav, Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import { AttachmentPinSymbolSVG } from 'src/Member/img/NotificationSVG';
import './MessageListComponent.scss';
import { formatMessageTime } from 'src/common/utils';
import { ListMessageIcon } from 'src/Admin/img/messages/MessageIcons';

function MessageListComponent({
  item,
  onClick,
  itemIndex = 0,
  selectedIndex = 0,
}) {
  const TruncatedHtml = ({ content, maxLength }) => {
    let modifiedContent = '';
    if (content?.startsWith('"') && content?.endsWith('"')) {
      modifiedContent = content?.substring(1, content?.length - 1);
    } else {
      modifiedContent = content;
    }
    const splitedContent = modifiedContent?.split(
      item?.MessageSentReceived === 'S' ? '\n' : '\\n',
    )[0];
    const trimedConent = splitedContent?.replaceAll('&nbsp;', '\u00A0');

    if (trimedConent?.length <= maxLength || trimedConent === undefined) {
      return (
        <div
          dangerouslySetInnerHTML={{ __html: trimedConent ? trimedConent : '' }}
        />
      );
    }

    const truncatedContent = trimedConent?.substring(0, maxLength) + '...';

    return <div dangerouslySetInnerHTML={{ __html: truncatedContent }} />;
  };

  return (
    <div className="published-message-list-admin">
      <Nav.Item
        className="messages-list-margin"
        onClick={onClick}
        key={item.id}
      >
        <Nav.Link className={selectedIndex === itemIndex ? 'active' : null}>
          <Row>
            <Col md={2} className="pt-2">
              <span className="message-user-icon-img">
                <ListMessageIcon className="message-icon" />
              </span>
            </Col>
            <Col md={6} className="d-flex flex-column pl-0 pr-0 pt-1">
              {item?.EventTitle?.length > 27 ? (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 450 }}
                  overlay={
                    <Popover>
                      <Popover.Content>
                        <div className="tooltip-header">{item?.EventTitle}</div>
                      </Popover.Content>
                    </Popover>
                  }
                >
                  <div className="message-subject-ellipsis">
                    <TruncatedHtml
                      content={item?.EventTitle?.trim()?.substring(
                        0,
                        item?.EventTitle?.length - 1,
                      )}
                      maxLength={25}
                    />
                  </div>
                </OverlayTrigger>
              ) : (
                <div className="message-title">{item?.EventTitle}</div>
              )}
              {item?.EventDesc?.length > 30 ? (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 450 }}
                  overlay={
                    <Popover>
                      <Popover.Content>
                        <div className="tooltip-header">
                          <TruncatedHtml
                            content={item.EventDesc?.trim()}
                            maxLength={item.EventDesc?.length}
                          />
                        </div>
                      </Popover.Content>
                    </Popover>
                  }
                >
                  <div className="message-subject-ellipsis">
                    <TruncatedHtml
                      content={item.EventDesc?.trim()?.substring(
                        1,
                        item.EventDesc?.length - 1,
                      )}
                      maxLength={25}
                    />
                  </div>
                </OverlayTrigger>
              ) : (
                <div className="message-subject">
                  <TruncatedHtml
                    content={item.EventDesc?.trim()}
                    maxLength={item.EventDesc?.length}
                  />
                </div>
              )}
            </Col>
            <Col className="text-right pl-0 pt-2">
              <div className="d-flex justify-content-end">
                <span className="pr-1">
                  {item.attachments === true ? (
                    <AttachmentPinSymbolSVG className="attachmentsymbol-svg" />
                  ) : (
                    ''
                  )}
                </span>
                <span className="user-type-data">
                  {item?.userType === 'Member'
                    ? 'Member/Dependent'
                    : item?.userType}
                </span>
              </div>
              <span className="message-received">
                {formatMessageTime(item.ReceivedDateTime)}
              </span>
            </Col>
          </Row>
        </Nav.Link>
      </Nav.Item>
    </div>
  );
}

export default MessageListComponent;
